import { Button } from '@material-ui/core';
import styled, { keyframes } from 'styled-components';

export const StyledSecondIFrameContainer = styled.div<{ width: string }>`
    width: ${({ width }) => `${width}`};
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    font-family: Roboto, Helvetica, Arial, sans-serif;
    position: relative;
`;

export const StyledSecondIFrame = styled.iframe`
    border: none;
    height: 100%;
`;

export const StyledSubmittedContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
`;

export const StyledSubmittedTitle = styled.span`
    font-size: 20px;
    font-weight: 500;
    height: 22px;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    margin-top: 30px;
`;

export const StyledSubmittedDesc = styled.span`
    font-size: 14px;
    color: #757575;
    font-weight: normal;
    height: 22px;
    letter-spacing: 0.25px;
    line-height: 20px;
    text-align: center;
    margin-top: 12px;
`;

export const StyledToggleContainer = styled.div<{ width: number }>`
    width: ${({ width }) => `${width}px`};
    background: #f3f3f3;
    display: flex;
    align-items: center;
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
`;

export const StyledToggleButton = styled(Button)`
    && {
        color: #afafaf;
        padding: 0;
        min-width: auto;
        width: 16px;
        height: 100%;
    }
`;

export const StyledLoadingContainer = styled.div<{ visible: boolean }>`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: ${({ visible }) => (visible ? 'flex' : 'none')};
    justify-content: center;
    align-items: center;
    z-index: 999;
    background: rgba(255, 255, 255, 1);
`;

const loadingAnimation = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const StyledLoading = styled.div`
    width: 42px;
    height: 42px;
    border: 5px solid #f5f5f5;
    border-bottom-color: #bababa;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    animation: ${loadingAnimation} 1s infinite linear;
`;
